import { useState } from "react";

// * Components
import CustomButton from "./CustomButton";

// * Images
import logoImg from "../assets/images/logos/textonly_nobuffer_transparent.png";

// * MUI Components
import {
  Box,
  Container,
  Drawer,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Typography,
  styled,
} from "@mui/material";

// * MUI Icons
import MenuIcon from "@mui/icons-material/Menu";
import {
  Contacts,
  FeaturedPlayList,
  Home,
  ListAlt,
  MiscellaneousServices,
} from "@mui/icons-material";

// * Styled Components
const NavbarContainer = styled(Container)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  padding: theme.spacing(5),
  [theme.breakpoints.down("md")]: {
    padding: theme.spacing(3),
  },
}));

const NavbarLogo = styled("img")(({ theme }) => ({
  cursor: "pointer",
  maxHeight: "40px",
  width: "auto",
  [theme.breakpoints.down("md")]: {
    display: "none",
  },
}));

const NavbarLinkBox = styled(Box)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  columnGap: 25,
  [theme.breakpoints.down("md")]: {
    display: "none",
  },
}));

const NavbarLink = styled(Typography)(({ theme }) => ({
  color: "#2B3674",
  fontWeight: "600",
  cursor: "pointer",
  textDecoration: "none",
  transition: "color 0.3s ease",
  "&:hover": {
    color: "#3370FF",
  },
}));

const MenuBox = styled(Box)(({ theme }) => ({
  cursor: "pointer",
  [theme.breakpoints.up("md")]: {
    display: "none",
  },
}));

// * Functions
const ListComponent = ({ onClose }) => {
  const menuItems = [
    { text: "Home", id: "home", icon: <Home /> },
    { text: "How It Works", id: "how-it-works", icon: <MiscellaneousServices /> },
    { text: "Features", id: "features", icon: <FeaturedPlayList /> },
    { text: "Security", id: "security", icon: <ListAlt /> },
    { text: "About", id: "about", icon: <Contacts /> },
  ];

  return (
    <List
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "space-between",
        justifyContent: "center",
        width: 200,
      }}
    >
      {menuItems.map((item) => (
        <ListItem key={item.text} disablePadding>
          <ListItemButton
            onClick={() => {
              document.getElementById(item.id)?.scrollIntoView({ behavior: 'smooth' });
              onClose();
            }}
          >
            <ListItemIcon>{item.icon}</ListItemIcon>
            <ListItemText primary={item.text} />
          </ListItemButton>
        </ListItem>
      ))}
    </List>
  );
};

export default function Navbar() {
  const [showMenu, setShowMenu] = useState(false);

  return (
    <NavbarContainer>
      <Box>
        <MenuBox onClick={(e) => setShowMenu(true)}>
          <MenuIcon />
        </MenuBox>
        <Drawer
          anchor="left"
          open={showMenu}
          onClose={(e) => setShowMenu(false)}
        >
          <ListComponent onClose={() => setShowMenu(false)} />
        </Drawer>
        <NavbarLogo src={logoImg} alt="logo" />
      </Box>

      <NavbarLinkBox>
        <NavbarLink
          component="a"
          href="#home"
          onClick={(e) => {
            e.preventDefault();
            document.getElementById('home')?.scrollIntoView({ behavior: 'smooth' });
          }}
        >
          Home
        </NavbarLink>
        <NavbarLink
          component="a"
          href="#how-it-works"
          onClick={(e) => {
            e.preventDefault();
            document.getElementById('how-it-works')?.scrollIntoView({ behavior: 'smooth' });
          }}
        >
          How It Works
        </NavbarLink>
        <NavbarLink
          component="a"
          href="#features"
          onClick={(e) => {
            e.preventDefault();
            document.getElementById('features')?.scrollIntoView({ behavior: 'smooth' });
          }}
        >
          Features
        </NavbarLink>
        <NavbarLink
          component="a"
          href="#security"
          onClick={(e) => {
            e.preventDefault();
            document.getElementById('security')?.scrollIntoView({ behavior: 'smooth' });
          }}
        >
          Security
        </NavbarLink>
        <NavbarLink
          component="a"
          href="#about"
          onClick={(e) => {
            e.preventDefault();
            document.getElementById('about')?.scrollIntoView({ behavior: 'smooth' });
          }}
        >
          About
        </NavbarLink>
      </NavbarLinkBox>

      <Box sx={{ display: "flex", alignItems: "center", columnGap: 2 }}>
        <Box
          component="a"
          href="https://dev.dizpurse.com"
          target="_blank"
          rel="noopener noreferrer"
          sx={{ textDecoration: "none" }}
        >
          <CustomButton
            backgroundColor="#b7e9f4"
            color="#2B3674"
            buttonText="Sign In"
            style={{
              fontWeight: "600",
            }}
          />
        </Box>
        <Box
          onClick={() => {
            document.getElementById('waitlist')?.scrollIntoView({ behavior: 'smooth' });
          }}
        >
          <CustomButton
            backgroundColor="#3370FF"
            color="#fff"
            buttonText="Join Waitlist"
          />
        </Box>
      </Box>
    </NavbarContainer>
  );
}
